import { RelatedLP } from '../../../related/RelatedPages';
export default function Page() { return <RelatedLP slug="butler-academy" locale="en" />; }
